import { useParams } from 'react-router-dom';
import { getServiceUrl } from '../../api-v2/apis-request';
import { useEffect, useState } from 'react';
import GridLoader from 'react-spinners/GridLoader';
import '../../styles/tailwind.css';
import { Switch, Case } from 'react-if';
import { isMobile } from 'react-device-detect';

const CashOutRequest = () => {
	const { uuid } = useParams();
	const [status, setStatus] = useState('');
	const [isLoading, setIsLoading] = useState(true);
	const [user, setUser] = useState({
		id: '',
		fullName: '',
	});

	useEffect(() => {
		confirmCashoutRequest();
	}, []);

	const confirmCashoutRequest = async () => {
		setIsLoading(true);
		const baseUrl = getServiceUrl('user-wallet/write');

		const {
			status,
			error,
			user,
			redirectUrl = '',
		} = await fetch(`${baseUrl}/cashout/request/${uuid}/confirm`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		}).then((res) => res.json());

		setStatus(status ? 'success' : error);

		if (user) {
			setUser(user);

			if (isMobile && redirectUrl) {
				window.location.replace(redirectUrl);
			}
		}

		setIsLoading(false);
	};

	return (
		<div className="main-container w-full h-screen bg-gradient-to-r from-[#170827] to-[#301A47] relative overflow-hidden mx-auto my-0">
			<div className="w-full h-screen absolute  z-[53]">
				<div className="w-full md:w-[598px] h-[576.102px] bg-[url(img/cashout/d14bdd8f-68f9-4efd-b1f6-16509ce2242f.png)] bg-cover bg-no-repeat absolute top-0 left-0" />

				<div className="w-[140px] h-[39px] bg-[url(img/cashout/a5c95925-1fb6-463b-aa45-ddb688e1f850.png)] bg-contain bg-no-repeat absolute top-[100px] left-[35%] md:top-[146.789px] md:left-[204px] z-[52]" />
				<div className="w-[56px] h-[56px] bg-[url(img/cashout/762e04cc-6d08-4b28-a17b-810f0608ddd6.png)] bg-cover bg-no-repeat absolute top-[219px] left-[1304px] z-[42]" />
				<div className="hidden md:block w-[120px] h-[120px] absolute top-[333px] left-[230px] overflow-hidden z-[3]">
					<div className="w-[107.143px] h-[90.728px] bg-[url(img/cashout/7fd35afa-ffa2-4f4e-9a10-71e96001d636.png)] bg-[length:100%_100%] bg-no-repeat relative z-[4] mt-[14.572px] mr-0 mb-0 ml-[6.429px]" />
				</div>
				<div className="w:full md:w-[590.491px] h-[451px] bg-[url(img/cashout/4e175e6b-4edb-45e2-a7c0-2ed90966e4ea.png)] bg-cover bg-no-repeat absolute top-[362px] left-[1222px] z-[1]" />

				<Switch>
					<Case condition={isLoading}>
						<div className="w-full h-screen flex justify-center items-center z-[55]">
							<GridLoader size={80} color="#fff" />
						</div>
					</Case>
					<Case condition={status === 'success'}>
						<div className="flex w-full h-full flex-col gap-[32px] items-center flex-nowrap absolute translate-x-0  z-[43] justify-center">
							<div className="w-[160px] h-[160px] shrink-0 bg-[url(img/cashout/4cede106-d772-41c1-8cc1-0bb8b9d791f4.png)] bg-cover bg-no-repeat relative overflow-hidden z-[44]" />
							<div className="flex w-full flex-col gap-[16px] justify-center items-center shrink-0 flex-nowrap relative z-[45]">
								<span className="text-2xl flex w-[948px] h-[56px] justify-center items-start shrink-0 basis-auto font-['Roboto'] md:text-[48px] font-bold leading-[56px] text-[#fff] relative text-center whitespace-nowrap z-[46]">
									Congratulations {user.fullName}!
								</span>
								<div className="flex w-full px-2 text-center flex-col items-start shrink-0 flex-nowrap relative z-[47]">
									<span className="flex w-full h-[24px] justify-center items-start shrink-0 basis-auto font-['Roboto'] text-sm md:text-[18px] font-medium leading-[24px] text-[#fff] relative text-center whitespace-nowrap z-[48]">
										Your cash out request has been successfully approved.
									</span>
									<span className="w-full justify-center items-start basis-auto font-['Roboto'] text-xs md:text-[16px] font-normal leading-[24px] text-[#ababab] relative text-center z-[49]">
										Your money should arrive within 3 business days. You will be notified by email once
										sent.
									</span>
								</div>
							</div>
						</div>
					</Case>
					<Case condition={status === 'invalid'}>
						<div className="flex w-full h-full flex-col gap-[32px] items-center flex-nowrap absolute translate-x-0  z-[43] justify-center">
							<div className="w-[180px] h-[180px] shrink-0 bg-[url(img/cashout/error-icon.png)] bg-cover bg-no-repeat relative overflow-hidden z-[44]" />
							<div className="flex w-full flex-col gap-[16px] justify-center items-center shrink-0 flex-nowrap relative z-[45]">
								<span className="text-2xl flex w-[948px] h-[56px] justify-center items-start shrink-0 basis-auto font-['Roboto'] md:text-[48px] font-bold leading-[56px] text-[#fff] relative text-center whitespace-nowrap z-[46]">
									Invalid Request!
								</span>
								<div className="flex w-full px-2 text-center flex-col items-start shrink-0 flex-nowrap relative z-[47]">
									<span className="flex w-full h-[24px] justify-center items-start shrink-0 basis-auto font-['Roboto'] text-sm md:text-[18px] font-medium leading-[24px] text-[#fff] relative text-center whitespace-nowrap z-[48]">
										This request is invalid, please check your email received
									</span>
								</div>
							</div>
						</div>
					</Case>
					<Case condition={status === 'expired'}>
						<div className="flex w-full h-full flex-col gap-[32px] items-center flex-nowrap absolute translate-x-0  z-[43] justify-center">
							<div className="w-[180px] h-[180px] shrink-0 bg-[url(img/cashout/error-icon.png)] bg-cover bg-no-repeat relative overflow-hidden z-[44]" />
							<div className="flex w-full flex-col gap-[16px] justify-center items-center shrink-0 flex-nowrap relative z-[45]">
								<span className="text-2xl flex w-[948px] h-[56px] justify-center items-start shrink-0 basis-auto font-['Roboto'] md:text-[48px] font-bold leading-[56px] text-[#fff] relative text-center whitespace-nowrap z-[46]">
									Expired
								</span>
								<div className="flex w-full px-2 text-center flex-col items-start shrink-0 flex-nowrap relative z-[47]">
									<span className="flex w-full h-[24px] justify-center items-start shrink-0 basis-auto font-['Roboto'] text-sm md:text-[18px] font-medium leading-[24px] text-[#fff] relative text-center whitespace-nowrap z-[48]">
										This request is expired
									</span>
									<span className="flex w-full h-[24px] justify-center items-start shrink-0 basis-auto font-['Roboto'] text-xs md:text-[16px] font-normal leading-[24px] text-[#ababab] relative text-center whitespace-nowrap z-[49]">
										Requests are valid for 24 hours after being requested, please make a new
										request.
									</span>
								</div>
							</div>
						</div>
					</Case>
				</Switch>

				<div className="w-[72px] h-[72px] bg-[url(img/cashout/8bbe10f3-f6a0-4f26-a619-3efe9a08af61.png)] bg-cover bg-no-repeat absolute top-[735px] left-[270px] overflow-hidden z-[41]" />
			</div>
			<div className="w-full h-[1020px] bg-[url(img/cashout/6bd3d628-9da0-4f94-8d5d-6bd2787b009e.png)] bg-cover bg-no-repeat absolute top-0 left-0 overflow-hidden z-[2]" />
			<div className="hidden md:flex w-[607px] h-[56.23%] fixed top-[53.64%] left-[-350px] z-[36]">
				<div className="w-[99.34%] h-[94.33%] bg-[url(img/cashout/a6957f43-3ead-4002-82cc-301dcde85629.png)] bg-[length:100%_100%] bg-no-repeat absolute top-0 left-0 z-[25]" />
				<div className="w-[99.42%] h-[94.03%] bg-[url(img/cashout/dadaec6f-2234-484b-9366-f2da87f88de6.png)] bg-[length:100%_100%] bg-no-repeat absolute top-0 left-0 z-[36]">
					<div className="w-[308.801px] h-[149.072px] bg-[url(img/cashout/98efac7a-1b93-40d0-a946-389d71e4893d.png)] bg-[length:100%_100%] bg-no-repeat relative z-[21] mt-[277.98px] mr-0 mb-0 ml-[291.89px]" />
				</div>
				<div className="w-full md:w-[51.87%] h-[55.19%] bg-[url(img/cashout/a851cf4d-404d-46f0-9abe-72417ff82cd5.png)] bg-[length:100%_100%] bg-no-repeat absolute top-[44.81%] left-[48.13%] z-[12]">
					<div className="w-[316.976px] h-[317.791px] bg-[url(img/cashout/87e87630-92e7-4313-ba53-692b36b0f329.png)] bg-[length:100%_100%] bg-no-repeat relative z-[14] mt-[0.02px] mr-0 mb-0 ml-[0.06px]">
						<div className="w-[39.97%] h-[98.01%] bg-[url(img/cashout/40564661-4d05-4c4b-b958-354bed9840d5.png)] bg-[length:100%_100%] bg-no-repeat absolute top-[0.43%] left-[0.05%] z-[37]" />
						<div className="w-[54.37%] h-[75.98%] rounded-[60.61px] absolute top-[3.52%] left-[40.48%] overflow-hidden z-[38]">
							<div className="w-[181.466px] h-[173.142px] opacity-40 relative z-[39] mt-[-0.01px] mr-0 mb-0 ml-[7.15px]">
								<div className="w-full h-full bg-[url(img/cashout/a1f8a6eb-181b-4842-a235-71eb21389cf2.png)] bg-[length:100%_100%] bg-no-repeat absolute top-0 left-0 z-40" />
							</div>
						</div>
						<div className="w-[96.48%] h-[46.36%] bg-[url(img/cashout/3da3c40e-409a-4c9b-8038-4aa2cb1302f5.png)] bg-[length:100%_100%] bg-no-repeat absolute top-[5.84%] left-[-0.01%] z-[32]" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default CashOutRequest;
